import { Injectable, inject, Injector } from '@angular/core';
import { switchMap, withLatestFrom, map, catchError, combineLatest, filter } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import {Store} from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppDownload, AppDownloadEntities } from '../app-download.model';
import * as fromStore from '../../../store';
import {TranslateService} from '@ngx-translate/core';
import { AppDownloadService } from '../../../services/app-download.service';
import { AppDownloadActionTypes, AppDownloadActions } from '../actions/app-download.actions';
import * as featureActions from '../../index';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';

@Injectable()
export class AppDownloadEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private appDownloadService = inject(AppDownloadService);
  private injector = inject(Injector);


  constructor() {}

  GetAppDownloads$ = createEffect(() => this.actions$.pipe(
    ofType(AppDownloadActionTypes.GetAppDownloads),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const today = new Date();
      const enddate = today.getFullYear() + '/' + (today.getMonth() + 1);
      const param = {
        otp: user.otp,
        type: action.payload.type,
        start_date: '2019/12',
        end_date: enddate,
      };
      return this.appDownloadService.ReadAppDownload(param).pipe(
        map((res: any) => {
          if (res.result) {
            const result: AppDownloadEntities = {
              AppDownloadNode: res.msg.body,
              start_date: action.payload.start_date,
              end_date: action.payload.end_date
            };
            return new featureActions.LoadAppDownloads(result);
          } else {
            return new featureActions.GetUserActivityLogsFail();
          }
        })
      );
    })
  ));
  UpdateAppDownloads$ = createEffect(() => this.actions$.pipe(
    ofType(AppDownloadActionTypes.UpdateAppDownloads),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        year: action.payload.year,
        region: action.payload.region,
        idata: action.payload.idata,
        adata: action.payload.adata
      };
      return this.appDownloadService.UpdateAppDownload(params).pipe(
        switchMap((res) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.UpdateAppDownloadData
          };
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: this.injector.get(TranslateService).instant('Update Failed') })];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.UpdateAppDownloadData
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
}
